import React from "react";

import { HubCardStack } from "../../components";
import { useGetOrdersByPartData } from "../../hooks";
import { OrdersTable } from "../../tables";

export const PartDetailsOrders = ({ id }) => {
  const { data } = useGetOrdersByPartData(id);
  return (
    <HubCardStack margin="15px">
      <OrdersTable rows={data?.rows || []} meta={data?.meta || {}} />
    </HubCardStack>
  );
};

export default PartDetailsOrders;
